import ClipboardJS from 'clipboard';
import moment from 'moment';
import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet } from './helpers/axiosHelper';
import { getMtaApBasicData, hydrateApBasicData } from './helpers/basicHelper';
import { byId } from './helpers/utility';






authHelper.validate();
hydrateApBasicData();






const referCodeInput = byId('referCodeInput');


const myReferralsTableBodyElement = byId('myReferralsTableBodyElement');





var referCodeInput_clipboard = new ClipboardJS('#referCodeInput_clipboard');


referCodeInput_clipboard.on('success', function (e) {


    e.clearSelection();
    Swal.fire({
        icon: 'success',
        title: 'Refer Code Copied 🥰', toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });
});




referCodeInput.value = getMtaApBasicData().appUsername;


















const getMyReferralsListFun = async () => {
    try {


        const response = await callTheApServerGet(`/basic/getMyReferralsList`);
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);

            if (res.myReferralsList.length > 0) {









                myReferralsTableBodyElement.innerHTML = '';
                let i = 0;
                while (res.myReferralsList.length > i) {

                    const { referredByEarnings, all_owners } = res.myReferralsList[i];
                    const { createdAt, web_app_details } = all_owners;

                    const { name } = web_app_details[0];





                    const date = moment(createdAt * 1000).format('DD/MM/YYYY');
                    const time = moment(createdAt * 1000).format('LT');
                    myReferralsTableBodyElement.innerHTML += `<tr>
                                <th scope="row">${i + 1}</th>
                              
                                <td>${name}</td>
                                <td>₹${referredByEarnings}</td>
                                <td>${date} <br> ${time}</td>
                               
                                 
                            </tr>`;

                    i++;
                }
            } else {

                myReferralsTableBodyElement.innerHTML = `  <tr >
                <th colspan='4' class='text-center'>Referrals Not found 😢 <br> Refer Now 🥰 </th>

            </tr>`;
            }


        }
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }
};

getMyReferralsListFun();



